module.exports = __webpack_public_path__ + "img/back-ground-left.486f5b3a.png";